import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import { atomWithStorage } from "jotai/utils";

export const latestViewedProductsAtom = atomWithStorage<IProduct[]>(
  "latest_viewed_products",
  []
);
